import { useState } from 'react';
import { cn } from '@rocco/utils/cn';
import { useWebsiteTrackingProxy } from '~/modules/tracking/hook/useWebsiteTrackingProxy';
import { RICH_TEXT_CLASS } from '~/utils/rich-text';
import Specifications from '../product-details/Specifications';
import type Product from '../../type/product';

interface DescriptionProps {
    product: Product;
    /** Whether to show the specifications section. Defaults to true. */
    showSpecifications?: boolean;
}

const Description = ({
    product,
    showSpecifications = true,
}: DescriptionProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const clickProxy = useWebsiteTrackingProxy(
        {
            professionalID: product.Professional.ID,
            professionalTitle: product.Professional.Title,
            itemType: 'Product',
            link: product.Professional.Link,
        },
        {
            attachUTM: true,
            processRelativeURL: true,
        },
    );

    return (
        <div
            className="pb-8 pt-10 text-base leading-normal md:pb-0 md:pt-0"
            onClick={clickProxy}
            onContextMenu={clickProxy}
        >
            <div
                className={cn(
                    'relative overflow-hidden md:max-h-none md:overflow-visible after:md:hidden',
                    !isExpanded &&
                        'after:bg-linear-to-t max-h-[4.5rem] after:pointer-events-none after:absolute after:bottom-0 after:left-0 after:right-0 after:h-10 after:from-white after:to-transparent',
                )}
            >
                <div
                    className={cn(
                        'cms-rich-text text-sm leading-[1.3] text-gray-800 md:text-[1.1rem] md:leading-normal',
                        RICH_TEXT_CLASS,
                    )}
                    dangerouslySetInnerHTML={{
                        __html: product.Content ?? '',
                    }}
                />
                {showSpecifications && <Specifications data={product} />}
            </div>
            {!isExpanded && (
                <div className="mt-2 md:hidden">
                    <button
                        className="py-1 text-sm font-medium leading-[1.3] text-gray-800 underline"
                        onClick={() => setIsExpanded(true)}
                    >
                        Read more
                    </button>
                </div>
            )}
        </div>
    );
};

export default Description;
